import React from "react";
import Story from "./story/story";
import "./stories.css";

const Stories = () => {
  return (
    <div className="stories-wrapper">
      <Story
        image="https://images.unsplash.com/photo-1654651419487-29cf6957fb35?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=464&q=80"
        profileSrc="https://images.unsplash.com/photo-1602524206684-fdf6393c7d89?ixid=MX
        wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit
        =crop&w=1350&q=80"
        title="Nabendu"
      />
      <Story
        image="https://images.unsplash.com/photo-1648737154448-ccf0cafae1c2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
        profileSrc="https://images.unsplash.com/photo-1602524206684-fdf6393c7d89?ixid=MX
        wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit
        =crop&w=1350&q=80"
        title="TWD"
      />
      <Story
        image="https://images.unsplash.com/photo-1654612870179-cc1c965d6b4e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=872&q=80"
        profileSrc="https://images.unsplash.com/photo-1602524206684-fdf6393c7d89?ixid=MX
        wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit
        =crop&w=1350&q=80"
        title="Nabendu"
      />
    </div>
  );
};

export default Stories;
